import { createAction } from '@reduxjs/toolkit';

export const setCoOrdersFilter = createAction('setCoOrdersFilter');
export const resetCoOrdersFilter = createAction('resetCoOrdersFilter');
